import React, { Component } from 'react';
import ExamImg from '../exams/examImg';

class ExamImgModal extends Component {
    state = {
        originClass: false,
        originbtnClass: false,
        imgBtnClass: false,
        btnInitialClass: true
    };
    
    handleOriginView = () => {
        const originClass = this.state.originClass;
        this.setState({originClass: true});

        const originbtnClass = this.state.originbtnClass;
        this.setState({originbtnClass: true});
    };

    handleInitialView = () => {
        const originClass = this.state.originClass;
        this.setState({originClass: false});

        const originbtnClass = this.state.originbtnClass;
        this.setState({originbtnClass: false});
    };

    handleImgView = () => {
        const imgBtnClass = this.state.imgBtnClass;
        this.setState({imgBtnClass: !imgBtnClass});

        const btnInitialClass = this.state.btnInitialClass;
        this.setState({btnInitialClass: false});
        console.log(`imgBtnClass: ${imgBtnClass}`);
    };
    render() {
        return (
            <section className={this.props.imgViewClass === true ? "popup-show img-view-popup popup-wrap flex-column align-items-center justify-content-center position-fixed" : "img-view-popup popup-wrap flex-column align-items-center justify-content-center position-fixed"}>
                <article className="popup-container d-flex flex-column">
                    <div className="popup-header d-flex align-items-center">
                        <h1 className="title w-100 m-0 text-center">원본 사진보기</h1>
                        <button type="button" className="btn close-btn img-close-btn" onClick={this.props.onImgClose}>
                            <span className="icon-wrap">
                                <svg className="icon close-btn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path className="fill this-target" d="M153.212,158l4.537-4.537a.857.857,0,0,0-1.212-1.212L152,156.788l-4.537-4.537a.857.857,0,0,0-1.212,1.212L150.788,158l-4.537,4.537a.857.857,0,0,0,1.212,1.212L152,159.212l4.537,4.537a.857.857,0,0,0,1.212-1.212Z" transform="translate(-140 -146)" fill="#999"/>
                                </svg>
                            </span>
                        </button>
                    </div>
                    <ul className="popup-body m-0 d-flex flex-column align-items-center">
                        <li className="img-container w-100 d-flex flex-column align-items-center scroll-wrapper position-relative">
                            <div className="sub d-flex justify-content-end align-items-center">
                                <h1 className="sub-title bold m-0 text-center position-absolute">사진1</h1>
                                <div className="btn-wrap d-fex position-relative">
                                    <button type="button" className={this.state.originbtnClass? "btn original-btn active" : "btn original-btn"} onClick={this.handleOriginView}>원본보기</button>
                                    <button type="button" className={this.state.originbtnClass? "btn initial-btn" : "btn initial-btn active"} onClick={this.handleInitialView}>원래대로</button>
                                </div>
                            </div>
                            <ExamImg originClass={this.state.originClass} />
                        </li>
                        
                        <li className="btn-wrap d-flex align-items-center w-100">
                            <button>
                                <input type="radio" id="imgbtn01" name="img-btn" className="d-none" onClick={this.handleImgView}></input>
                                <label htmlFor="imgbtn01" className={this.state.btnInitialClass === true ? "img-btn-label initial-active" : "img-btn-label"}>사진1</label>
                            </button>
                            <button>
                                <input type="radio" id="imgbtn02" name="img-btn" className="d-none" onClick={this.handleImgView}></input>
                                <label htmlFor="imgbtn02" className={this.state.btnInitialClass === true ? "img-btn-label" : "img-btn-label"}>사진2</label>
                            </button>
                        </li>
                    </ul>
                </article>
            </section>
        );
    }
}

export default ExamImgModal;